const translations = {
  de: {
    startGame: "Spiel starten",
    restart: "Neu starten",
    quit: "Beenden",
    timeLabel: "Zeit:",
    elapsedSeconds: "{seconds} Sekunden",
    elapsedMinutesSeconds: "{minutes} Minuten {seconds} Sekunden",
  },
  en: {
    startGame: "Start game",
    restart: "Restart",
    quit: "Quit",
    timeLabel: "Time:",
    elapsedSeconds: "{seconds} sec",
    elapsedMinutesSeconds: "{minutes} min {seconds} sec",
  },
  fr: {
    startGame: "Démarrer le jeu",
    restart: "Recommencer",
    quit: "Quitter",
    timeLabel: "Temps :",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  es: {
    startGame: "Iniciar juego",
    restart: "Reiniciar",
    quit: "Salir",
    timeLabel: "Tiempo:",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  it: {
    startGame: "Inizia il gioco",
    restart: "Ricomincia",
    quit: "Esci",
    timeLabel: "Tempo:",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  nl: {
    startGame: "Spel starten",
    restart: "Opnieuw starten",
    quit: "Afsluiten",
    timeLabel: "Tijd:",
    elapsedSeconds: "{seconds} sec",
    elapsedMinutesSeconds: "{minutes} min {seconds} sec",
  },
  pl: {
    startGame: "Rozpocznij grę",
    restart: "Zagraj ponownie",
    quit: "Zakończ",
    timeLabel: "Czas:",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  pt: {
    startGame: "Iniciar jogo",
    restart: "Reiniciar",
    quit: "Sair",
    timeLabel: "Tempo:",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  cs: {
    startGame: "Spustit hru",
    restart: "Hrát znovu",
    quit: "Ukončit",
    timeLabel: "Čas:",
    elapsedSeconds: "{seconds} s",
    elapsedMinutesSeconds: "{minutes} min {seconds} s",
  },
  da: {
    startGame: "Start spil",
    restart: "Start forfra",
    quit: "Afslut",
    timeLabel: "Tid:",
    elapsedSeconds: "{seconds} sek",
    elapsedMinutesSeconds: "{minutes} min {seconds} sek",
  },
  sv: {
    startGame: "Starta spelet",
    restart: "Starta om",
    quit: "Avsluta",
    timeLabel: "Tid:",
    elapsedSeconds: "{seconds} sek",
    elapsedMinutesSeconds: "{minutes} min {seconds} sek",
  },
  tr: {
    startGame: "Oyunu başlat",
    restart: "Yeniden başlat",
    quit: "Çık",
    timeLabel: "Süre:",
    elapsedSeconds: "{seconds} sn",
    elapsedMinutesSeconds: "{minutes} dk {seconds} sn",
  },
  uk: {
    startGame: "Почати гру",
    restart: "Почати знову",
    quit: "Вийти",
    timeLabel: "Час:",
    elapsedSeconds: "{seconds} с",
    elapsedMinutesSeconds: "{minutes} хв {seconds} с",
  },
}

function normalizeLanguage(value) {
  return typeof value === "string" &&
    Object.prototype.hasOwnProperty.call(translations, value)
    ? value
    : "de"
}

function getMessages(language) {
  const selected = translations[normalizeLanguage(language)]
  const german = translations.de
  const messages = {}

  for (const key of Object.keys(german)) {
    messages[key] =
      Object.prototype.hasOwnProperty.call(selected, key) &&
      typeof selected[key] === "string" &&
      selected[key].length > 0
        ? selected[key]
        : german[key]
  }

  return messages
}

function formatElapsedTimeText(time, language = "de") {
  const totalHundredths = Math.max(0, Math.round(time * 100))
  const minutes = Math.floor(totalHundredths / 6000)
  const seconds = Math.floor((totalHundredths % 6000) / 100)
  const hundredths = totalHundredths % 100
  const formattedSeconds = `${seconds}.${String(hundredths).padStart(2, "0")}`
  const messages = getMessages(language)

  if (minutes > 0) {
    return messages.elapsedMinutesSeconds
      .replace("{minutes}", String(minutes))
      .replace("{seconds}", formattedSeconds)
  }

  return messages.elapsedSeconds.replace("{seconds}", formattedSeconds)
}

module.exports = {
  translations,
  normalizeLanguage,
  getMessages,
  formatElapsedTimeText,
}
